var getCountAnsweredAndQuestions = function getCountAnsweredAndQuestions(screening) {
  var answeredCount = 0;
  var questionCount = 0;
  var questions = screening && screening.questions || [];
  questions.forEach(function (question) {
    if (question.type !== 'html') {
      var _question$answer, _question$answers;
      // Increment questionCount only for non-'html' questions
      questionCount++;

      // Increment answeredCount for non-'html' questions if answered
      if ((_question$answer = question.answer) !== null && _question$answer !== void 0 && _question$answer.active || ((_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.length) > 0) {
        answeredCount++;
      }
    }
  });
  return {
    questionCount: questionCount,
    answeredCount: answeredCount
  };
};
export default getCountAnsweredAndQuestions;
//# sourceMappingURL=getCountAnsweredAndQuestions.js.map